export const sourceNames = [
  {
    value: '台電',
    label: '台電',
    yearlyAmount: 0,
    co2Kwh: 0.509,
  },
  {
    value: '煤炭',
    label: '煤炭',
    yearlyAmount: 0,
    co2Kwh: 900,
  },
  {
    value: ' 天然氣',
    label: '天然氣',
    yearlyAmount: 0,
    co2Kwh: 400,
  },
  {
    value: '核能',
    label: '核能',
    yearlyAmount: 0,
    co2Kwh: 4,
  },
  {
    value: '風力發電',
    label: '風力發電',
    yearlyAmount: 0,
    co2Kwh: 10,
  },
  {
    value: '光電',
    label: '光電',
    yearlyAmount: 0,
    co2Kwh: 100,
  },
  {
    value: '水力發電',
    label: '水力發電',
    yearlyAmount: 0,
    co2Kwh: 18,
  },
]
